import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppSharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewFeatureComponent } from './preview-feature.component';



@NgModule({
    declarations: [
        PreviewFeatureComponent
    ],
    imports: [
        CommonModule,
        AppSharedModule,
        FormsModule,
        ReactiveFormsModule
    ],
    exports: [
        PreviewFeatureComponent
    ]
})
export class PreviewFeatureModule {
    static entry = PreviewFeatureComponent;

 }
